// import components
import { styled, Box } from '@mui/material';

export const StyledCareReceiversHomeBox = styled(Box)(({ theme }) => ({
  margin: theme.spacing(3, 3, 14, 3)
}));

export const StyledPatientSelectorBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  alignItems: 'flex-end'
}));

export const StyledTopBox = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(3)
}));

export const StyledBottomBox = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2)
}));
